import { Permission } from "../../../contexts/permissions/fetchPermissions";

export const hasRequiredPermissions = (
  permissions: Permission[],
  requiredPermissionKeys: string[]
) => {
  const permissionSet = new Set<string>();
  permissions.forEach(p => {
    if (p.permitted) {
      permissionSet.add(p.request.permission);
    }
  });

  const hasAllPermissions = requiredPermissionKeys.every(k =>
    permissionSet.has(k)
  );
  return hasAllPermissions;
};
